import { Patient } from '../../api/fetchAppointmentsV2';
import { AP } from '../../pages/types/appointments';

export const SHOW_GOOGLE_REVIEW_KNOW_MORE_DIALOG = 'SHOW_GOOGLE_REVIEW_KNOW_MORE_DIALOG';

export interface ShowGoogleReviewKnowMoreDialogEvent {
    type: typeof SHOW_GOOGLE_REVIEW_KNOW_MORE_DIALOG;
}

export const EXPORT_ALL_PT = 'EXPORT_ALL_PT';

export interface ExportAllPtEvent {
    type: typeof EXPORT_ALL_PT;
}

export const INIT_MEDICAL_CERTIFICATE = 'INIT_MEDICAL_CERTIFICATE';

export interface InitMedicalCertificateEvent {
    type: typeof INIT_MEDICAL_CERTIFICATE;
    ap: AP;
}

export const OPEN_URL_IN_IFRAME_DIALOG = 'OPEN_URL_IN_IFRAME_DIALOG';

export interface ToggleIframeActionDialogEvent {
    type: typeof OPEN_URL_IN_IFRAME_DIALOG;
    url: string;
}

export const ON_APPT_ACTION = 'ON_APPT_ACTION';

export const ON_PATIENT_EDIT_ACTION = 'ON_EDIT_PATIENT';

export interface OnApptActionEvent {
    type: typeof ON_APPT_ACTION;
    a: AP;
    cId: string;
}

export const BILLING_POPUP = 'BILLING_POPUP';
export const REQUEST_PAYMENT = 'REQUEST_PAYMENT';
export const ON_REQUEST_MEDICAL_RECORDS = 'ON_REQUEST_MEDICAL_RECORDS';
export const ON_ADD_ADDRESS = 'ON_ADD_ADDRESS';

export interface RequestPaymentEvent {
    type: typeof REQUEST_PAYMENT;
    data: {
        aid?: string | null;
        patient: Patient;
        uhid?: string | null;
        clinicId: string;
        source: 'request-payment';
        aptDate?: string;
        serviceInfo?: {
            id: number;
            name: string;
            price: number;
        };
    };
}

export interface BillPopupEvent {
    type: typeof BILLING_POPUP;
    data: {
        aid?: string | null;
        patient: Patient;
        uhid?: string | null;
        clinicId: string;
        source:
            | 'apt-queue'
            | 'apt-queue-view-receipts'
            | 'new-patients'
            | 'all-patients'
            | 'prescription'
            | 'billing-queue'
            | 'settle-due';
        aptDate?: string;
        serviceInfo?: {
            id: number;
            name: string;
            price: number;
        };
        appointment?: AP;
    };
}

export interface RequestMedicalRecordsEvent {
    type: typeof ON_REQUEST_MEDICAL_RECORDS;
    a: AP;
}

export interface AddAddressEvent {
    type: typeof ON_ADD_ADDRESS;
    a: AP;
}

export const ON_BILL_PATIENT = 'ON_BILL_PATIENT';

export interface BillPatientEvent {
    type: typeof ON_BILL_PATIENT;
    a: AP;
}

export const ON_REFER_PATIENT = 'ON_REFER_PATIENT';

export interface ReferPatientEvent {
    type: typeof ON_REFER_PATIENT;
    a: AP;
}

export const ON_SHOW_SA = 'ON_SHOW_SA';

export interface OnShowSAtEvent {
    type: typeof ON_SHOW_SA;
    a: AP;
}

export const ON_CREATE_TEMPLATE = 'ON_CREATE_TEMPLATE';

export interface OnCreateTemplateEvent {
    type: typeof ON_CREATE_TEMPLATE;
    a: AP;
}

export const ON_ORDER_MEDICINE = 'ON_ORDER_MEDICINE';
export const ON_BOOK_LAB_TEST = 'ON_BOOK_LAB_TEST';

export interface OnOrderMedicineEvent {
    type: typeof ON_ORDER_MEDICINE;
    a: AP;
}

export interface OnBookLabTestEvent {
    type: typeof ON_BOOK_LAB_TEST;
    a: AP;
}

export const ON_ENTER_VITALS = 'ON_ENTER_VITALS';

export interface OnEnterVitalsEvent {
    type: typeof ON_ENTER_VITALS;
    a: AP;
}

export const CREATE_ABHA = 'CREATE_ABHA';

export interface CreateAbhaEvent {
    type: typeof CREATE_ABHA;
    a: AP;
}

export interface OnPatientEditEvent {
    type: typeof ON_PATIENT_EDIT_ACTION;
    a: AP;
}

export type Events =
    | ShowGoogleReviewKnowMoreDialogEvent
    | InitMedicalCertificateEvent
    | ToggleIframeActionDialogEvent
    | OnApptActionEvent
    | ExportAllPtEvent
    | RequestPaymentEvent
    | BillPopupEvent
    | BillPatientEvent
    | ReferPatientEvent
    | OnShowSAtEvent
    | OnCreateTemplateEvent
    | OnOrderMedicineEvent
    | OnBookLabTestEvent
    | OnEnterVitalsEvent
    | RequestMedicalRecordsEvent
    | AddAddressEvent
    | OnPatientEditEvent
    | CreateAbhaEvent;

export const REFRESH_APPT = 'REFRESH_APPT';

export interface RefreshApptEvent {
    type: typeof REFRESH_APPT;
}

export type IncomingEvents = RefreshApptEvent;
